import { Configuration, LogLevel } from '@azure/msal-browser';

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID;
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID;

if (!tenantId || !clientId) {
  throw new Error('Missing required environment variables: VITE_ENTRA_TENANT_ID and/or VITE_ENTRA_CLIENT_ID');
}

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
    },
  },
};

/**
 * Delegated scopes for Microsoft Graph.
 * These require admin consent in the Entra app registration.
 */
export const graphScopes = [
  'User.Read.All',
  'Mail.Send',
  'UserAuthMethod-Passkey.ReadWrite.All',
];

export const loginRequest = {
  scopes: graphScopes,
};
